/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAllQuestions } from '../fn/top-intervention-controller/get-all-questions';
import { GetAllQuestions$Params } from '../fn/top-intervention-controller/get-all-questions';
import { postTopIntervention } from '../fn/top-intervention-controller/post-top-intervention';
import { PostTopIntervention$Params } from '../fn/top-intervention-controller/post-top-intervention';
import { TopInterventionTypeListDto } from '../models/top-intervention-type-list-dto';

@Injectable({ providedIn: 'root' })
export class TopInterventionControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postTopIntervention()` */
  static readonly PostTopInterventionPath = '/v1/top-securite';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postTopIntervention()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postTopIntervention$Response(
    params: PostTopIntervention$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<{}>> {
    return postTopIntervention(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postTopIntervention$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postTopIntervention(params: PostTopIntervention$Params, context?: HttpContext): Observable<{}> {
    return this.postTopIntervention$Response(params, context).pipe(map((r: StrictHttpResponse<{}>): {} => r.body));
  }

  /** Path part for operation `getAllQuestions()` */
  static readonly GetAllQuestionsPath = '/v1/top-securite/questions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllQuestions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllQuestions$Response(
    params?: GetAllQuestions$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<TopInterventionTypeListDto>> {
    return getAllQuestions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllQuestions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllQuestions(params?: GetAllQuestions$Params, context?: HttpContext): Observable<TopInterventionTypeListDto> {
    return this.getAllQuestions$Response(params, context).pipe(
      map((r: StrictHttpResponse<TopInterventionTypeListDto>): TopInterventionTypeListDto => r.body)
    );
  }
}
